import React, { useState, useEffect } from "react";
import logo from "../assets/images/logo.png";

function Navbar() {
  const [userEmail, setUserEmail] = useState("");


  useEffect(() => {
    const token = localStorage.getItem("Token");
    const email = localStorage.getItem("Email");

    if (token && email) {
      setUserEmail(email);
    } else {
      setUserEmail("");
    }
  }, []);

  const displayUserName = userEmail ? userEmail.split('@')[0] : '';

  return (
    <nav className="navbar navbar-expand-lg fixed-top">
      <a className="navbar-brand" href="/">
        <img src={logo} className="logo" alt="Logo" />
      </a>

      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon">
          <i
            className="fa fa-bars"
            style={{
              color: "white",
              fontSize: "18px",
              backgroundColor: "#75c4c0",
              padding: "10px",
              border: "none",
            }}
            aria-hidden="true"
          ></i>
        </span>
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav ml-auto">
          <li className="nav-item active">
            <a className="nav-link" href="/">Home</a>
          </li>

          <li className="nav-item">
            <a
              className="nav-link"
              href="/docs/index.html"
              target="_blank"
              rel="noopener noreferrer"
            >
              Documentation
            </a>
          </li>

          <li className="nav-item">
            <a className="nav-link" href="/faq">FAQ</a>
          </li>

          <li className="nav-item">
            <a className="nav-link" href="/contact">Contact Us</a>
          </li>

          <li className="nav-item d-flex align-items-center">
  {userEmail ? (
    <a
      href="/project/view"
      className="text-decoration-none"
    >
      <div
        className="btn btn-sm d-flex align-items-center p-2 rounded-3 border-0"
        style={{        
          backdropFilter: 'blur(10px)',
          transition: 'all 0.3s ease'
        }}
      >
        <div
          className="rounded-circle me-2 d-flex align-items-center justify-content-center"
          style={{
            width: '32px',
            height: '32px',
            background: 'linear-gradient(135deg, #75C4C0 0%, #75C4C0 100%)',
            color: 'white',
            fontSize: '0.8rem',
            fontWeight: 600
          }}
        >
          {displayUserName.charAt(0).toUpperCase()}
        </div>

        {/* Email */}
        <div className="d-none d-lg-block text-start">
          <div className="fw-medium" style={{fontSize: "14px"}}>
            {displayUserName}
          </div>
        </div>
      </div>
    </a>
  ) : (
    <a
      className="nav-link login-link"
      style={{ padding: "10px 30px", textAlign: "center" }}
      href="/login"
    >
      Login
    </a>
  )}
</li>

        </ul>
      </div>
    </nav>
  );
}

export default Navbar;